<h1>Contact</h1>
<div>
  <h2>Technical and Member Support</h2>
  <a routerLink="/support">Support Desk</a><br />
  <a href="mailto:support@tytnetwork.com">support&#64;tytnetwork.com</a>
</div>

<div>
  <h2>Advertising</h2>
  Tom Schwarting<br />
  <a href="mailto:advertising@tytnetwork.com">advertising&#64;tytnetwork.com</a>
</div>

<div>
  <h2>ShopTYT.com Support</h2>
  <a routerLink="/support">Support Desk</a><br />
  <a href="mailto:orders@tytnetwork.com">orders&#64;tytnetwork.com</a>
</div>

<div>
  <h2>Jobs and Internships</h2>
  <a href="mailto:tytjobs@tytnetwork.com">tytjobs&#64;tytnetwork.com</a>
</div>

<div>
  <h2>Legal Inquiries</h2>
  <a href="mailto:legal@tytnetwork.com">legal&#64;tytnetwork.com</a>
</div>
<div>
  <h2>Media and Press Contact</h2>
  Peter Axtman / Kurt Gonska / Danielle Fuerth<br />
  <a href="mailto:press@tytnetwork.com">press&#64;tytnetwork.com</a>
</div>

<div>
  <h2>Feedback, Ideas, Comments, Stories, Leads</h2>
  <a href="mailto:feedback@tytnetwork.com">feedback&#64;tytnetwork.com</a>
</div>

<div>
  <h2>Regular Mail and Packages</h2>
  The Young Turks<br />
  6230 Wilshire Blvd, Box #140<br />
  Los Angeles, CA 90048<br />
</div>